<template>
    <div v-if="service" class="service-info">
        <h1 class="title">Name: {{ service.name }}</h1>
        <div class="form">
            <form @submit.prevent="updateService">
                <InputContent label="Name" v-model="name" />
                <label>
                    <div class="label">Description</div> 
                    <textarea type="text" id="description" v-model="description"
                        placeholder="Edit a description...">
                    </textarea>
                </label>
                <br />
                <div class="buttons">
                    <button v-if="isServiceChanged" class="button" type="submit"
                        :disabled="loading">
                        Update Service
                    </button>
                    <router-link :to="{ name: 'ServicesList' }">
                            <button class="button" type="button">Cancelar</button>
                    </router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import InputContent from '@/components/inputs/Content.vue'

export default {
    name:'ServicesInfo',
    props: {
        id: {
            required: true
        },
    },

    components: {
        InputContent,
    },

    data() {
        return {
            options: [
                { text: `Choose the role`, value: 'role' },
                { text: `Consumer`, value: 'consumer' },
                { text: `Worker`, value: 'worker' },
                { text: `Admin`, value: 'admin' },
            ],
            name: "",
            loading: false,
        }
    },

    methods: {
        async updateService() {
            this.loading = true;
            try {
                this.$store.dispatch('services/edit', { service: this.serviceData })
                this.$router.push({ name: 'ServicesList' })

            } catch (error) {
                console.log('Error updating service');
            }
        },
    },

    computed: {
        isServiceChanged() {
            return this.name !== this.service.name;
        },
        service() {
            return this.$store.getters['services/id'](this.id)
        },
        serviceData() {
            return {
                id: this.id,
                name: this.name,
                description: this.description
            }
        },
    },

    watch: {
        service: {
            immediate: true,
            handler() {
                if (this.service != null) {
                    this.name = this.service.name
                    this.description = this.service.description
                }
            },
        }
    },

    async mounted() {
        this.$store.dispatch('services/getAll')
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.service-info {
    padding: 0 2rem;

    .title {}

    .form {
        background-color: var(--sidebar-bg-color);
        padding: 20px;
        border: 1px solid none;
        border-radius: 10px;
        box-shadow: 0 3px 6px rgba(var(--black), .16), 0 3px 6px rgba(var(--black), .23);

        form {

            label {
                input[type=text] {
                    display: none;

                    &+.label {
                        padding: 1rem;
                        border: 2px dashed;
                        border-radius: 10px;
                        width: fit-content;
                    }
                }

            }
            textarea {
                outline: none;
                padding: .5rem;
                width: 100%;
                background-color: var(--bg-color-2);
                border: 2px solid var(--bg-color-2);
                color: var(--text-color);
                border-radius: 5px;
                height: 300px;

                &:focus {
                    border: 2px solid var(--highlight-color);
                    box-shadow: 0 0 0 1px var(--highlight-color), inset 0 0 0 1px var(--highlight-color);
                }
            }
        }
        .buttons {
            margin: 1rem 0;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 1rem;
            width: 100%; 
            
            button {
                flex: 1;
                padding: .5rem;
                font-size: 18px;
                cursor: pointer;
                text-align: center;
                border: none; 
                border-radius: 5px;
                background-color: var(--text-color);
                color: var(--white);
                transition: background-color 0.3s ease;

                &:hover {
                    background-color: var(--highlight-color, 10%); 
                }

                &[type="button"] {
                    background-color: var(--text-second-color);
                    &:hover {
                        background-color: var(--text-darken-color);
                    }
                }
            }
        }
    }
}
</style>
